import { createFileRoute } from '@tanstack/react-router';
import { SupplierCreationPage } from '@/features/suppliers/components/SupplierCreationPage';

export const Route = createFileRoute('/$commiteeSlug/suppliers/create')({
  component: SupplierCreationPage,
});
